import { useState } from 'react';

import { Card, Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import Layout from 'components/Layout/Layout';

import OperatorModal from './components/OperatorModal';
import VanCard from './components/VanCard';
import CrewSkeletonGrid from './components/VanCardSkeleton';
import VansBlockedState from './components/VansBlockedState';
import VansFilters from './components/VansFilters';
import { useVans } from './hooks/useVans';
import { useVansScope } from './hooks/useVansScope';

import './Vans.scss';

const SKELETON_CARDS = 3;

function Vans() {
  const { t } = useTranslation();

  const scope = useVansScope();
  const [includeInactive, setIncludeInactive] = useState(false);
  const [operatorId, setOperatorId] = useState<string | undefined>(undefined);

  const { loading: vansLoading, vans } = useVans({
    distributorId: scope.selectedDistributorId,
    includeInactive,
  });

  const openOperator = (id: string) => setOperatorId(id);
  const closeOperator = () => setOperatorId(undefined);

  if (scope.loading) {
    return (
      <Layout title="">
        <Card loading />
      </Layout>
    );
  }

  if (scope.blockedReason) {
    return (
      <Layout title="">
        <VansBlockedState reason={scope.blockedReason} />
      </Layout>
    );
  }

  return (
    <Layout title="">
      <VansFilters
        distributors={scope.distributors}
        selectedDistributorId={scope.selectedDistributorId}
        onDistributorChange={scope.setSelectedDistributorId}
        singleDistributor={scope.singleDistributor}
        includeInactive={includeInactive}
        onIncludeInactiveChange={setIncludeInactive}
        disabled={vansLoading}
        vansCount={vans.length}
      />

      <div className="vans-grid">
        {vansLoading
          ? Array.from({ length: SKELETON_CARDS }).map((_, index) => (
              <CrewSkeletonGrid key={index} />
            ))
          : vans.map((van) => (
              <VanCard key={van.id} van={van} onCrewClick={openOperator} />
            ))}
      </div>

      {!vansLoading && vans.length === 0 && (
        <Card style={{ marginTop: '12px' }}>
          <Empty
            description={
              <span className="vans-empty">
                <span>{t('scenes.vans.scene.empty.title')}</span>
                <span className="vans-empty__hint">
                  {t('scenes.vans.scene.empty.hint')}
                </span>
              </span>
            }
          />
        </Card>
      )}

      <OperatorModal
        operatorId={operatorId}
        isOpen={!!operatorId}
        onClose={closeOperator}
      />
    </Layout>
  );
}

export default Vans;
